module.exports = __webpack_public_path__ + "img/Airbnb-Working-From-Home-Desktop2-scaled.69e8655c.jpg";